import { render, staticRenderFns } from "./GuestDetails.vue?vue&type=template&id=0d6df968&scoped=true"
import script from "./GuestDetails.vue?vue&type=script&lang=js"
export * from "./GuestDetails.vue?vue&type=script&lang=js"
import style0 from "./GuestDetails.vue?vue&type=style&index=0&id=0d6df968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6df968",
  null
  
)

export default component.exports